import { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { IFilterManifest } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";

interface Props {
  setValue: UseFormSetValue<IFilterManifest>;
  getValues: UseFormGetValues<IFilterManifest>;
  reset: () => void;
  control: Control<IFilterManifest, any>;
  isFilterVisible: boolean;
}

const ManifestFilter = ({
  setValue,
  getValues,
  isFilterVisible,
  reset,
  control,
}: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-4 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter<IFilterManifest>
            url={APIS.VEHICLE}
            queryKey={"vehicle"}
            name={"vehicle"}
            label={"Vehicle Number"}
            params={{
              is_active: true,
            }}
            placeholder={"Search vehicle"}
            control={control}
          />
          <ComboboxFilter<IFilterManifest>
            url={APIS.DRIVER}
            queryKey={"driver"}
            name={"driver"}
            label={"Driver"}
            params={{
              is_active: true,
            }}
            placeholder={"Search driver"}
            control={control}
          />
          <ComboboxFilter<IFilterManifest>
            url={APIS.BRANCH}
            queryKey={"branch"}
            name={"owner_branch"}
            label={"Branch"}
            params={{
              is_active: true,
            }}
            placeholder={"Search branch"}
            control={control}
          />
        </div>
      ) : (
        ""
      )}
      <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
        Reset
      </button>
    </div>
  );
};

export default ManifestFilter;
